import React, { useEffect } from 'react';
import Pagination from './Pagination';
import PropTypes from 'prop-types';

function PaginationWrapper ({ inputData, setSortedData, pageLimit, pageNeighbours, updateParent }) {
    //Paired with Pagination component
    const onPageChanged = (data) => {
        // console.log(data);
        let { currentPage, pageLimit } = data;
        let offset = (currentPage - 1) * pageLimit;
        //console.log(offset);
        setSortedData(inputData.slice(offset, offset + pageLimit));
    };

    useEffect(() => {
        if(inputData && inputData.length === 0) {
            setSortedData(inputData);
        }
    }, [inputData, setSortedData]);

    return (
        <>
            {inputData && inputData.length > 0 ? (
                <div>
                    <Pagination totalRecords={inputData} pageLimit={pageLimit} pageNeighbours={pageNeighbours} onPageChanged={onPageChanged} updateParent={updateParent} />
                </div>
            ) : null}
        </>
    );
}

PaginationWrapper.propTypes = {
    inputData: PropTypes.array,
    setSortedData: PropTypes.func, 
    pageLimit: PropTypes.number,
    pageNeighbors: PropTypes.number,
    updateParent: PropTypes.func
};

export default PaginationWrapper;